export default {
    getHTMLTemplate(state) {
        return state.template_html;
    },
    getHTMLTemplateLoaded(state) {
        return state.loaded;
    }
};